export const ApplicationActionBarEN = {
    "applicationActionBar": {
        "tab": {
            "detail": "Detail",
            "fileAttach": "Attachment"
        },
        "item": {
            "delete": "Delete",
            "auditing": "Activity history",
            "update": "Update",
            "approval": "Approve",
            "back": "Back"
        },
        "message": {
            "deleteAsk": "Are you sure you want to delete?",
            "approvalAsk": "Are you sure you want to approve the application?",
            "assignSuccess": "Assigned successfully",
        },
        "button": {
            "assignToMe": "Assign to me",
        }
    }
}